module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0145.jpg?v=a5e84f45";